'use client';

import { useEffect, useState } from 'react';

import { getMySubscriptionStatus } from '~/lib/server/actions/subscription-actions';

export function useSubscriptionStatus() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [tier, setTier] = useState('free');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMySubscriptionStatus()
      .then((result) => {
        setIsSubscribed(result.isSubscribed);
        setTier(result.tier);
      })
      .catch(() => {
        // Silent fail — treat as free user
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { isSubscribed, tier, loading };
}
